// DUNS number is 9 digits
export const dunsNumberValidationPattern = new RegExp(/^[0-9]{9}$/)
